// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ChargingTimes_TheComp__6W2Fw"};